<template>
  <div class="question-info-comp">
    <div class="title">{{ seqNo }}.{{ questionInfo.subject }}</div>
    <div class="tags">
      <div class="tag difficult" :class="[calcDifficultyClass(questionInfo.difficulty_level)]">
        {{ questionInfo.difficulty_level }}
      </div>
      <div class="tag category">
        {{ questionInfo.category }}
      </div>
    </div>

    <div class="options">
      <div class="option" v-for="(option, index) in questionInfo.options" :key="index">
        {{ no[option.seq - 1] }} : {{ option.content }}
      </div>
    </div>

    <div class="answer">
      <span class="label">答案：</span>
      {{ showRightSeq(questionInfo.options) }}
    </div>

    <div class="explanation" v-if="showExplanation && questionInfo.explanation">
      解析：{{ questionInfo.explanation }}
    </div>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop } from 'kuaidong-component'
import { IPaperQuestion, IPaperQuestionOptions } from 'kuaidong-model'
@Component({
  components: {},
})
export default class QuestionInfo extends BaseComponent {
  @Prop({ type: Object, required: true })
  questionInfo!: IPaperQuestion

  @Prop({ type: Number, required: true })
  seqNo!: number

  @Prop({ type: Boolean, default: false })
  showExplanation!: boolean

  no = ['A', 'B', 'C', 'D']

  showRightSeq(options: IPaperQuestionOptions[]) {
    const rightOption = options.find((item) => {
      return item.is_right
    })
    return rightOption && this.no[rightOption.seq - 1]
  }

  calcDifficultyClass(difficulty_level: string) {
    if (difficulty_level === '简单') {
      return 'easy'
    } else if (difficulty_level === '中等') {
      return 'medium'
    } else {
      return 'hard'
    }
  }
}
</script>
<style lang="less">
.question-info-comp {
  padding: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  > .title {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: #2d2f33;
    text-align: left;
  }

  > .tags {
    margin-top: 10px;
    display: flex;

    > .tag {
      padding: 2px 4px;
      margin-right: 8px;
      border-radius: 4px;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #81848f;
      background: #f7f8fa;
      &.easy {
        color: #3bb528;
        background: #e4fae1;
      }

      &.medium {
        color: #7c41e3;
        background: #f6f2fe;
      }

      &.hard {
        color: #f24b53;
        background: #ffeeef;
      }
    }
  }

  > .options {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    > .option {
      text-align: left;
      margin-top: 10px;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      color: #2d2f33;
    }
  }

  > .answer {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    margin-top: 20px;
    color: #2d2f33;
    > span {
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      color: #3bb528;
    }
  }

  > .explanation {
    margin-top: 12px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #81848f;
    text-align: left;
  }
}
</style>
